import { FlexBox } from '@dixa/lib-shared-habla';
import cs from 'classnames';

import { ViewMode } from '../../hooks/useBulletinEditor';

import styles from './buttonToggle.module.scss';

type ButtonToggleProps = {
  /** Current view mode */
  value: ViewMode;
  /** Function called when value is changed */
  onChange: (value: ViewMode) => void;
};

/** Component to toggle between two states. */
export function ButtonToggle({
  value,
  onChange,
}: ButtonToggleProps): JSX.Element {
  return (
    <FlexBox className={styles.group}>
      <button
        className={cs(styles.button, value === 'editor' && styles.selected)}
        onClick={() => onChange('editor')}
      >
        Unpublished
      </button>

      <button
        className={cs(styles.button, value === 'saved' && styles.selected)}
        onClick={() => onChange('saved')}
      >
        Published
      </button>
    </FlexBox>
  );
}
